import type { SearchResultRow } from "@softmax/product-ux/search";
export const maxResultsPerGroup = 4;
export type PillSearchScope = "site" | "account" | "both";
export type PillSearchGroup = {
  heading: string;
  rows: SearchResultRow[];
  pending: boolean;
  failed: boolean;
  retry: () => void;
};
export type SearchState = {
  isPending: boolean;
  isError: boolean;
  refetch: () => Promise<unknown>;
};
export type SearchInputs = {
  query: string;
  ready: boolean;
  enabled: boolean;
};
export function pillSearchGroup({
  heading,
  rows,
  queries,
}: {
  heading: string;
  rows: SearchResultRow[];
  queries: SearchState[];
}): PillSearchGroup {
  return {
    heading,
    rows: rows.slice(0, maxResultsPerGroup),
    pending: queries.some((query) => query.isPending),
    failed: queries.some((query) => query.isError),
    retry: () => {
      for (const query of queries) void query.refetch();
    },
  };
}
export function matchesSearch({
  query,
  fields,
}: {
  query: string;
  fields: readonly (string | null | undefined)[];
}) {
  return fields.some((field) =>
    field?.toLowerCase().includes(query.toLowerCase()),
  );
}
export const formatSearchDate = (iso: string) =>
  new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric" });
